import { DataManager, WebApiAdaptor, Query } from '@syncfusion/ej2-data';
import {
  CheckBoxSelection,
  DropDownListComponent,
  FieldSettingsModel,
  Inject,
  MultiSelectComponent,
} from '@syncfusion/ej2-react-dropdowns';
import React from 'react';
interface IPropsDD {
  url: string;
  field: FieldSettingsModel;
  placeHolder?: string;
  id?: string;
  refDD?: (ref: DropDownListComponent) => void;
  value?: any;
  onChange?: (e: any) => void;
  itemTemplate?: any;
  valueTemplate?: any;
  text?: string;
  selected?: (e: any) => void;
  floatLabelType?: 'Auto' | 'Always' | 'Never';
  enablePersistence?: boolean;
}
interface IPropsMulti {
  url: string;
  field: FieldSettingsModel;
  placeHolder?: string;
  id?: string;
  refDD?: (ref: MultiSelectComponent) => void;
  value?: Array<any>;
  onChange?: (e: any) => void;
  filtering?: (e: any) => void;
  query?: Query;
  allowFiltering?: boolean;
  maximumSelectionLength?: number;
  itemTemplate?: (args: any) => JSX.Element;
  floatLabelType?: 'Auto' | 'Always' | 'Never';
  enablePersistence?: boolean;
}
export const GlobalDropDown = ({
  field,
  url,
  id,
  placeHolder,
  refDD,
  onChange,
  value,
  itemTemplate,
  text,
  valueTemplate,
  selected,
  floatLabelType,
}: IPropsDD) => {
  const data = new DataManager({
    url: process.env.REACT_APP_API_GLOBAL_URL + url,
    adaptor: new WebApiAdaptor(),
    crossDomain: true,
  });
  const theRef = (args: DropDownListComponent) => {
    refDD && refDD(args);
  };
  return (
    <div>
      <DropDownListComponent
        id={id}
        dataSource={data}
        fields={field}
        placeholder={placeHolder}
        ref={theRef}
        value={value}
        onChange={onChange}
        itemTemplate={itemTemplate}
        valueTemplate={valueTemplate}
        floatLabelType={floatLabelType}
        text={text}
        select={selected}
      />
    </div>
  );
};
const onFiltering = (
  dataSource: DataManager,
  searchCase: string = '',
  e: any
) => {
  let query = new Query().take(20);
  query = e.text !== '' ? query.where(searchCase, 'equal', e.text) : query;
  e.updateData(dataSource, query);
};
export const GlobalMultiSelection = ({
  field,
  url,
  id,
  placeHolder,
  refDD,
  onChange,
  value,
  query,
  allowFiltering,
  maximumSelectionLength,
  itemTemplate,
  floatLabelType,
  enablePersistence,
}: IPropsMulti) => {
  const data = new DataManager({
    url: process.env.REACT_APP_API_GLOBAL_URL + url,
    adaptor: new WebApiAdaptor(),
    crossDomain: true,
  });
  const theRef = (args: MultiSelectComponent) => {
    refDD && refDD(args);
  };
  return (
    <div>
      <MultiSelectComponent
        id={id}
        dataSource={data}
        fields={field}
        placeholder={placeHolder}
        ref={theRef}
        value={value}
        onChange={onChange}
        query={query}
        filtering={onFiltering.bind(this, data, field.text)}
        mode='CheckBox'
        showSelectAll={true}
        showClearButton={true}
        showDropDownIcon={true}
        floatLabelType={floatLabelType}
        allowFiltering={allowFiltering}
        maximumSelectionLength={maximumSelectionLength}
        itemTemplate={itemTemplate}
        enablePersistence ={enablePersistence}
      >
    
        <Inject services={[CheckBoxSelection]} />
      </MultiSelectComponent>
    </div>
  );
};
